module.exports = __webpack_public_path__ + "img/personEscort.831daa3a.svg";